import React, { useState, useContext } from "react";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../store";

function BasicDatePicker({handleChangeDate}) {
  const { PersonalStore } = useContext(RootStoreContext);
  const { birthday, updateData } = PersonalStore;
  const [access, setAccess] = useState(true);
  const [birth, setBirth] = useState(birthday);

  const handleBirth = (item) => {
    setBirth(item);
    handleChangeDate(item);
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label="請選擇您的生日"
        value={birth}
        onChange={handleBirth}
        renderInput={(params) => (
          <TextField style={{ width: "300px" }} {...params} />
        )}
        InputProps={{
          style: {
            fontSize: 14,
            height: 60,
          },
        }}
        maxDate={access !== 1 ? new Date() : ""}
      />
    </LocalizationProvider>
  );
}
export default observer(BasicDatePicker);
